module.exports = __webpack_public_path__ + "static/img/组 2891.abcd44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2891.png
// module id = bOl/
// module chunks = 0